import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "checkout-sidebar__section" };
const _hoisted_2 = { class: "mt-1" };
const _hoisted_3 = { class: "checkout-sidebar__section" };
const _hoisted_4 = { class: "mt-1" };
const _hoisted_5 = {
    key: 0,
    class: "checkout-sidebar__section"
};
const _hoisted_6 = { class: "mt-3" };
const _hoisted_7 = {
    key: 1,
    class: "checkout-sidebar__section"
};
const _hoisted_8 = { class: "mt-3" };
const _hoisted_9 = {
    key: 2,
    class: "checkout-sidebar__section"
};
const _hoisted_10 = { class: "flex items-start" };
const _hoisted_11 = { class: "flex-shrink-0" };
const _hoisted_12 = { class: "ml-3" };
const _hoisted_13 = { key: 0 };
const _hoisted_14 = { key: 1 };
const _hoisted_15 = {
    key: 0,
    class: "absolute inset-0 flex items-center justify-center bg-white/80 backdrop-blur-[2px] rounded-lg z-10"
};
const _hoisted_16 = { class: "text-center px-4" };
const _hoisted_17 = { class: "text-sm font-medium text-gray-700" };
const _hoisted_18 = { class: "text-xs text-gray-500 mt-1" };
import { computed } from "vue";
import { useTheme } from "../../composables/useTheme";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CheckoutRightSidebarBase',
    props: {
        orderType: {},
        customer: {},
        timeSelection: {},
        paymentMethod: {},
        deliveryAdditionalInfo: {},
        canSubmit: { type: Boolean },
        loading: { type: Boolean },
        totalAmount: {},
        formatPrice: {},
        error: {},
        orderCreated: { type: Boolean },
        createdOrder: {},
        orderData: {},
        subtotal: {},
        deliveryFee: {},
        serviceFee: {},
        openingHoursValidation: {},
        isBlockedByOpeningHours: { type: Boolean },
        paymentConfig: {},
        discountCodeConfig: {},
        theme: { default: () => ({
                container: 'bg-white rounded-xl shadow-lg border-2 border-gray-200 font-inter',
                warning: 'p-4 rounded-md border',
                warningIcon: 'w-5 h-5 mt-0.5',
                warningTitle: 'text-sm font-semibold mb-1',
                warningText: 'text-sm'
            }) },
        translations: { default: () => ({
                pickupNotAvailable: 'Abholung nicht möglich',
                deliveryNotAvailable: 'Lieferung nicht möglich',
                note: 'Hinweis',
                contactRestaurant: 'Bitte kontaktieren Sie das Restaurant direkt für weitere Informationen.',
                contactDataRequired: 'Kontaktdaten erforderlich',
                fillContactDataFirst: 'Bitte füllen Sie zuerst Ihre Kontaktdaten aus',
                deliveryAddressRequired: 'Lieferadresse erforderlich',
                provideDeliveryAddress: 'Bitte geben Sie Ihre Lieferadresse an',
                dataRequired: 'Daten erforderlich',
                fillAllFields: 'Bitte füllen Sie alle erforderlichen Felder aus'
            }) }
    },
    emits: ["update:orderType", "update:customer", "update:timeSelection", "update:paymentMethod", "open-contact-modal", "open-address-modal", "open-time-modal", "payment-method-selected", "apply-discount", "remove-discount", "clear-discount-error", "submit", "captcha-submit", "payment-success", "payment-error", "payment-cancel"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { theme: sharedTheme } = useTheme();
        const withOpacity = (hexColor, opacity) => {
            const hex = (hexColor || '').replace('#', '');
            if (!/^[0-9a-fA-F]{6}$/.test(hex))
                return hexColor;
            const alpha = Math.round(Math.min(1, Math.max(0, opacity)) * 255).toString(16).padStart(2, '0');
            return `#${hex}${alpha}`;
        };
        const warningBaseColor = computed(() => sharedTheme.value.colors.warning || sharedTheme.value.colors.primary || '#d97706');
        const warningBoxStyle = computed(() => ({
            backgroundColor: withOpacity(warningBaseColor.value, 0.12),
            borderColor: withOpacity(warningBaseColor.value, 0.35)
        }));
        const warningIconStyle = computed(() => ({ color: warningBaseColor.value }));
        const warningTitleStyle = computed(() => ({ color: warningBaseColor.value }));
        const warningTextStyle = computed(() => ({ color: warningBaseColor.value }));
        // Computed properties for safe type casting
        const safeOrderType = computed({
            get: () => props.orderType || "pickup",
            set: (value) => emit("update:orderType", value),
        });
        const safePaymentMethod = computed({
            get: () => props.paymentMethod || "manual",
            set: (value) => emit("update:paymentMethod", value),
        });
        // Update functions
        const updateOrderType = (value) => emit("update:orderType", value);
        const updateCustomer = (value) => emit("update:customer", value);
        const updateTimeSelection = (value) => emit("update:timeSelection", value);
        const updatePaymentMethod = (value) => emit("update:paymentMethod", value);
        // Validation: Check if basic contact data is complete
        const hasContactData = computed(() => {
            if (!props.customer)
                return false;
            const hasName = props.customer.name && props.customer.name.trim().length > 0;
            const hasEmail = props.customer.email && props.customer.email.trim().length > 0;
            const hasPhone = props.customer.phone && props.customer.phone.trim().length > 0;
            return hasName && hasEmail && hasPhone;
        });
        // Validation: Check if delivery address is complete
        const hasDeliveryAddress = computed(() => {
            if (props.orderType !== 'delivery')
                return true;
            if (!props.customer?.address)
                return false;
            const hasStreet = props.customer.address.street && props.customer.address.street.trim().length > 0;
            const hasCity = props.customer.address.city && props.customer.address.city.trim().length > 0;
            const hasPostalCode = props.customer.address.postalCode && props.customer.address.postalCode.trim().length === 5;
            return hasStreet && hasCity && hasPostalCode;
        });
        // Combined validation
        const isCustomerDataComplete = computed(() => {
            return hasContactData.value && hasDeliveryAddress.value;
        });
        // Validation messages
        const validationMessage = computed(() => {
            if (!hasContactData.value) {
                return {
                    title: props.translations?.contactDataRequired || 'Kontaktdaten erforderlich',
                    subtitle: props.translations?.fillContactDataFirst || 'Bitte füllen Sie zuerst Ihre Kontaktdaten aus'
                };
            }
            if (props.orderType === 'delivery' && !hasDeliveryAddress.value) {
                return {
                    title: props.translations?.deliveryAddressRequired || 'Lieferadresse erforderlich',
                    subtitle: props.translations?.provideDeliveryAddress || 'Bitte geben Sie Ihre Lieferadresse an'
                };
            }
            return {
                title: props.translations?.dataRequired || 'Daten erforderlich',
                subtitle: props.translations?.fillAllFields || 'Bitte füllen Sie alle erforderlichen Felder aus'
            };
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", {
                class: _normalizeClass(["checkout-sidebar", _ctx.theme.container])
            }, [
                _createCommentVNode(" Order Type Selection "),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _renderSlot(_ctx.$slots, "order-type-selection", {
                            orderType: safeOrderType.value,
                            updateOrderType: updateOrderType
                        }, () => [
                            _createCommentVNode(" Fallback: Project must provide this slot ")
                        ])
                    ])
                ]),
                _createCommentVNode(" Customer Data "),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _renderSlot(_ctx.$slots, "customer-data-form", {
                            customer: _ctx.customer,
                            updateCustomer: updateCustomer,
                            openContactModal: () => _ctx.$emit('open-contact-modal')
                        }, () => [
                            _createCommentVNode(" Fallback: Project must provide this slot ")
                        ])
                    ])
                ]),
                _createCommentVNode(" Delivery Address (nur bei Lieferung) "),
                (_ctx.orderType === 'delivery')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _renderSlot(_ctx.$slots, "delivery-address-form", {
                                address: _ctx.customer.address,
                                additionalInfo: _ctx.deliveryAdditionalInfo,
                                openAddressModal: () => _ctx.$emit('open-address-modal')
                            }, () => [
                                _createCommentVNode(" Fallback: Project must provide this slot ")
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" Time Selection (nur wenn innerhalb der Öffnungszeiten) "),
                (!_ctx.openingHoursValidation || _ctx.openingHoursValidation.isWithinHours)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _renderSlot(_ctx.$slots, "time-selection-form", {
                                timeSelection: _ctx.timeSelection,
                                updateTimeSelection: updateTimeSelection,
                                orderType: safeOrderType.value,
                                openTimeModal: () => _ctx.$emit('open-time-modal')
                            }, () => [
                                _createCommentVNode(" Fallback: Project must provide this slot ")
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" Opening Hours Warning "),
                (_ctx.openingHoursValidation && !_ctx.openingHoursValidation.isWithinHours)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", {
                            class: _normalizeClass(_ctx.theme.warning),
                            style: _normalizeStyle(warningBoxStyle.value)
                        }, [
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    (_openBlock(), _createElementBlock("svg", {
                                        class: _normalizeClass(_ctx.theme.warningIcon),
                                        style: _normalizeStyle(warningIconStyle.value),
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24"
                                    }, [...(_cache[0] || (_cache[0] = [
                                            _createElementVNode("path", {
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                "stroke-width": "2",
                                                d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                            }, null, -1 /* CACHED */)
                                        ]))], 6 /* CLASS, STYLE */))
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("h3", {
                                        class: _normalizeClass(_ctx.theme.warningTitle),
                                        style: _normalizeStyle(warningTitleStyle.value)
                                    }, [
                                        (_ctx.orderType === 'pickup')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.translations.pickupNotAvailable), 1 /* TEXT */))
                                            : (_ctx.orderType === 'delivery')
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.translations.deliveryNotAvailable), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                    ], 6 /* CLASS, STYLE */),
                                    _createElementVNode("p", {
                                        class: _normalizeClass(_ctx.theme.warningText),
                                        style: _normalizeStyle(warningTextStyle.value)
                                    }, _toDisplayString(_ctx.openingHoursValidation.message), 7 /* TEXT, CLASS, STYLE */),
                                    _createElementVNode("p", {
                                        class: _normalizeClass(_ctx.theme.warningText + ' mt-2'),
                                        style: _normalizeStyle(warningTextStyle.value)
                                    }, [
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.translations.note) + ":", 1 /* TEXT */),
                                        _createTextVNode(" " + _toDisplayString(_ctx.translations.contactRestaurant), 1 /* TEXT */)
                                    ], 6 /* CLASS, STYLE */)
                                ])
                            ])
                        ], 6 /* CLASS, STYLE */)
                    ]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" Payment Method "),
                _createElementVNode("div", {
                    class: _normalizeClass(["checkout-sidebar__section relative", {
                            'opacity-50 pointer-events-none': _ctx.isBlockedByOpeningHours || !isCustomerDataComplete.value
                        }])
                }, [
                    _createCommentVNode(" Overlay with message when customer data incomplete "),
                    (!isCustomerDataComplete.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                                _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fas fa-lock text-gray-400 text-2xl mb-2" }, null, -1 /* CACHED */)),
                                _createElementVNode("p", _hoisted_17, _toDisplayString(validationMessage.value.title), 1 /* TEXT */),
                                _createElementVNode("p", _hoisted_18, _toDisplayString(validationMessage.value.subtitle), 1 /* TEXT */)
                            ])
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Discount Code Input "),
                    _renderSlot(_ctx.$slots, "discount-code-input", { discountConfig: _ctx.discountCodeConfig }, () => [
                        _createCommentVNode(" Fallback: Optional, project can provide this slot ")
                    ]),
                    _createElementVNode("div", null, [
                        _renderSlot(_ctx.$slots, "payment-method-selection", {
                            paymentMethod: safePaymentMethod.value,
                            updatePaymentMethod: updatePaymentMethod,
                            orderType: safeOrderType.value
                        }, () => [
                            _createCommentVNode(" Fallback: Project must provide this slot ")
                        ])
                    ])
                ], 2 /* CLASS */),
                _createCommentVNode(" Submit Button "),
                _createElementVNode("div", {
                    class: _normalizeClass(["checkout-sidebar__section", { 'opacity-50 pointer-events-none': _ctx.isBlockedByOpeningHours }])
                }, [
                    _renderSlot(_ctx.$slots, "submit-button", {
                        canSubmit: _ctx.canSubmit && !_ctx.isBlockedByOpeningHours,
                        isLoading: _ctx.loading,
                        totalAmount: _ctx.totalAmount,
                        formatPrice: _ctx.formatPrice,
                        submit: () => _ctx.$emit('submit')
                    }, () => [
                        _createCommentVNode(" Fallback: Project must provide this slot ")
                    ])
                ], 2 /* CLASS */)
            ], 2 /* CLASS */));
        };
    }
});
